import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import UnitListView from './UnitListView'
import * as CommunityActionCreators from '../../actions/community'

class UnitListContainer extends React.Component {
  static propTypes = {
    communityId: PropTypes.number.isRequired,
    units: PropTypes.object.isRequired,
    unitsByCommunity: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      units: state.units,
      unitsByCommunity: state.unitsByCommunity,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { communityId, communityActions } = this.props
    communityActions.listCommunityUnits(communityId)
  }

  render() {
    const {
      communityId, units, unitsByCommunity,
    } = this.props
    const unitIds = unitsByCommunity[communityId] || []
    const communityUnits = []
    unitIds.forEach((unitId) => {
      if (units[unitId]) {
        communityUnits.push(units[unitId])
      }
    })
    return (
      <UnitListView units={communityUnits} />
    )
  }
}

export default connect(
  UnitListContainer.mapStateToProps,
  UnitListContainer.mapDispatchToProps,
)(UnitListContainer)
